import React from 'react';
import cx from 'classnames';
import styles from './intercomActivationView.module.scss';
import { Row, Col } from 'react-bootstrap';
import InputField from 'src/legacy/components/InputField';
import { localizedStrings } from 'src/localization/index.jsx';
import _ from 'lodash';



class IntercomActivationView extends React.Component {
  constructor(props){
    super(props);
    const integration = this.props.integration;

    this.state = {
      appId : integration && integration.configuration.appId || '', 
      alignment : integration && integration.configuration.alignment || "right",
      horizontalPadding : integration && integration.configuration.horizontalPadding || 20,
      verticalPadding : integration && integration.configuration.verticalPadding || 20,
      errors: {}
    }
    this._handleAuthenticationClick = this._handleAuthenticationClick.bind(this);
    this._handleSaveChangesClick = this._handleSaveChangesClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedIntercom = localizedStrings.components.integrations.intercom;
  }

  _handleFieldChange(field, e){
    let value = e.target.value;
    this.setState({
      [field]: value
    });
  }

  _handleSelectChange(field, e){
    this.setState({
      alignment: field
    })
  }

  _handleAuthenticationClick(source){
    let errors = this._validateForm();

    this.setState({
      errors: errors
    });

    if(Object.keys(errors).length > 0){      
      return;
    }
    this.props.activateAccount( this._prepareConfigurationDetails(), "intercom" )
    .then((response) => {
      if(response.type === "intercom" && source === "activate"){
        this.props.trackAdoptionMetricsForPluginConnectedEvent('Intercom');      
    }
    })
    .catch(error => {
      console.error("Error activating account:", error);
    });;
  }
  componentWillReceiveProps(nextProps) {
    const { integration } = nextProps;
    if (!_.isEqual(this.props.integration, nextProps.integration)) {
        const appId = _.get(integration, 'configuration.appId', '');
        this.setState({ appId });
    }
}

  _handleSaveChangesClick(){
    this.props.updateConfiguration( this._prepareConfigurationDetails(), "intercom" );
  }

  _handleCancelClick(){
    this.setState({
      appId : this.props.integration.configuration.appId,
      alignment : this.props.integration.configuration.alignment,
      horizontalPadding : this.props.integration.configuration.horizontalPadding,
      verticalPadding : this.props.integration.configuration.verticalPadding
    });
  }

  _prepareConfigurationDetails(){
    let configuration = {
      appId : this.state.appId,
      alignment : this.state.alignment,
      horizontalPadding : this.state.horizontalPadding,
      verticalPadding : this.state.verticalPadding
    }
    return configuration;
  }

  _validateForm(){
    var errors = {};
    if(!this.state.appId || this.state.appId.trim() == ''){
      errors['appId'] = this.localizedIntercom.error_messages.app_id;
    }
    if( this.state.horizontalPadding == ''){
      errors['horizontalPadding'] = this.localizedIntercom.error_messages.padding;
    }
    if( this.state.verticalPadding  == ''){
      errors['verticalPadding'] = this.localizedIntercom.error_messages.padding;
    }
    return errors;
  }

  calculateRightPosition(){
    let left = ( 240 - (this.state.horizontalPadding * 250 ) / 1366 );
    return left +'px'
  }

  calculateLeftPosition(){
    let left = ((this.state.horizontalPadding * 250 ) / 1366 );
    return left +'px'
  }

  calculateTopPosition(){
    let top = ( 188 - (this.state.verticalPadding * 250 ) / 1366 );
    return top +'px'
  }

  render(){

    const rightAligned = {
      left: this.calculateRightPosition(),
      top: this.calculateTopPosition()
    }

    const leftAligned = {
      left: this.calculateLeftPosition(),
      top: this.calculateTopPosition()
    }

    var advancedSettings = "https://docs.intercom.com/configure-intercom-for-your-product-or-site";
    if(this.state.appId && this.state.appId.length > 5){
      advancedSettings = `https://app.intercom.io/a/apps/${this.state.appId}/settings/messenger`;
    }

    return (
      <Row>
        <div className={styles.content}>
          <h1>{ this.localizedIntercom.activate.title }</h1>
          <Row>
          <Col sm={8} className = { styles.column }>
            <p>{ this.localizedIntercom.activate.sub_text }</p>
            <div className={styles.form}>
              <InputField 
                className={styles.field} 
                title={ this.localizedIntercom.activate.app_id }
                value = { this.state.appId }
                placeholder={ this.localizedIntercom.activate.placeholder }
                onChange={this._handleFieldChange.bind(this, 'appId')}
                errorMessage={this.state.errors['appId']}
              />
              <Row className = {cx(styles.row)}>
                <Col sm={3} className = {styles.alignment}>
                  <span> { this.localizedIntercom.activate.alignment } </span>
                </Col>
                <Col sm={9} className = {styles.alignment}>
                  <div className={styles.accessLevel}>
                    <i className={cx('fa',this.state.alignment == 'right' ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle')} onClick={this._handleSelectChange.bind(this, "right")} aria-hidden="true"></i>
                    <span>{ this.localizedIntercom.activate.right_down }</span>
                  </div>
                  <div className={styles.accessLevel}>
                    <i className={cx('fa', this.state.alignment == 'left' ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle')} onClick={this._handleSelectChange.bind(this, "left")} aria-hidden="true"></i>
                    <span>{ this.localizedIntercom.activate.left_down }</span>
                  </div> 
                </Col>
              </Row>
              <Row className = {styles.row}>
                <Col sm={6}>
                  <InputField
                    className={ styles.inputField }
                    title={ this.localizedIntercom.activate.horizontal_padding }
                    type="text"
                    value = { this.state.horizontalPadding }
                    onChange={this._handleFieldChange.bind(this, 'horizontalPadding')}
                    errorMessage={this.state.errors['horizontalPadding']}
                  />
                </Col>
                <Col sm={6}>
                  <InputField
                    className={ styles.inputField }
                    title={ this.localizedIntercom.activate.vertical_padding }
                    type="text"
                    value = { this.state.verticalPadding }
                    onChange={this._handleFieldChange.bind(this, 'verticalPadding')}
                    errorMessage={this.state.errors['verticalPadding']}
                  />
                </Col>
              </Row>
              {!this.props.integration &&
                <button className={styles.button} onClick={() => {
                  this._handleAuthenticationClick("activate")
                }}
                 disabled={this.props.activating}>
                {this.props.activating &&
                  `${this.localizedIntegrations.actions.activating}...`
                }

                {!this.props.activating &&
                  this.localizedIntegrations.actions.activate
                }
                </button>
              }
              {this.props.integration &&
                <div className={styles.alignment}>
                  <button className={styles.button} onClick={() => {
                    this._handleAuthenticationClick("save_changes")
                  }}
              disabled={this.props.activating}>
                  {this.props.activating &&
                    `${this.localizedCommons.actions.saving_changes}...`
                  }

                  {!this.props.activating &&
                    this.localizedCommons.actions.save
                  }
                  </button>
                  <button className={cx(styles.button, styles.cancel)} onClick = { this._handleCancelClick } >
                      { this.localizedCommons.actions.cancel }
                  </button>
                </div>
              }  
            </div>
          </Col>
          <Col sm={4} className = {styles.iconAlign}>
            <div className = {styles.background}>
              <div className = { styles.indicator }
                style = { this.state.alignment == 'right' ? rightAligned : leftAligned }>
              </div>
            </div> 
          </Col>
          </Row>    
          <Col sm={9} className = {styles.description}>
            {this.localizedIntercom.customization} <span><a href= {advancedSettings} target="_blank" > {this.localizedIntercom.advanced_settings} </a></span>
          </Col>
        </div>
      </Row>
    );
  }
}

export default IntercomActivationView;